import type { CoachingModal as Modal } from '@/core/state/appStore'
import type { VergabeStage } from './columns'

export type AufgabeKey =
  | 'verbisHochladen'
  | 'lebenslaufHochladen'
  | 'eintrittsfragebogenAusfuellen'
  | 'teilnehmerakteGegenzeichnen'
  | 'empfangsbestaetigungUnterschreiben'
  | 'informationspflichtenUnterschreiben'
  | 'notfallkontaktAusfuellen'
  | 'einwilligungAusfuellen'
  | 'einwilligungUnterschreiben'
  | 'sicherheitsunterweisungUnterschreiben'
  | 'verbisJobboerseUnterschreiben'
  | 'potenzialanalyseAusfuellen'
  | 'klettHochladen'
  | 'gevaHochladen'
  | 'bewertungsbogenJobcoach'
  | 'bewertungsbogenFachanleiter'
  | 'bewertungsbogenSprachlehrkraft'
  | 'kompetenzbilanzierung'
  | 'foerderplanErstellen'
  | 'foerderplanUnterschreiben'
  | 'foerderplanGegenzeichnen'
  | 'erstberichtErstellen'
  | 'erstberichtUnterschreiben'
  | 'erstberichtGegenzeichnen'
  | 'anwesenheitErfassen'
  | 'zwischenberichtErstellen'
  | 'zwischenberichtBesprechen'
  | 'abschlussberichtErstellen'
  | 'abschlussberichtBesprechen'
  | 'abschlussberichtVerbisHochladen'
  | 'abgeschlossen'
  | 'aktivierung1'
  | 'aktivierung2'
  | 'aktivierung3'
  | 'aktivierung4'
  | 'aktivierung5'
  | 'aktivierung6'
  | 'aktivierung7'
  | 'aktivierung8'
  | 'aktivierung9'
  | 'aktivierung10'
  | 'aktivierung11'
  | 'aktivierung12'
  | 'aktivierung13'
  | 'aktivierung14'
  | 'aktivierung15'
  | 'aktivierung16'
  | 'aktivierung17'

export type AufgabeEntry = {
  dbName: string
  stage: VergabeStage
  position: number
  landing?: { modal: Modal; tab: string }
}

const AKTIVIERUNG_LANDING: AufgabeEntry['landing'] = { modal: 'personal', tab: 'aktivierung' }

export const AUFGABE = {
  verbisHochladen: { dbName: "VerBIS-Screenshots hochladen", stage: 'verbis', position: 1 },
  lebenslaufHochladen: { dbName: "Lebenslauf hochladen", stage: 'verbis', position: 2 },
  eintrittsfragebogenAusfuellen: { dbName: "Eintrittsfragebogen ausfüllen", stage: 'teilnehmerakte', position: 3 },
  teilnehmerakteGegenzeichnen: { dbName: "Teilnehmerakte gegenzeichnen", stage: 'teilnehmerakte', position: 4 },
  empfangsbestaetigungUnterschreiben: { dbName: "Empfangsbestätigung unterschreiben lassen", stage: 'teilnehmerakte', position: 5 },
  informationspflichtenUnterschreiben: { dbName: "Informationspflichten unterschreiben lassen", stage: 'teilnehmerakte', position: 6 },
  notfallkontaktAusfuellen: { dbName: "Notfallkontakt ausfüllen", stage: 'teilnehmerakte', position: 7 },
  einwilligungAusfuellen: { dbName: "Einwilligung ausfüllen", stage: 'teilnehmerakte', position: 8 },
  einwilligungUnterschreiben: { dbName: "Einwilligung unterschreiben lassen", stage: 'teilnehmerakte', position: 9 },
  sicherheitsunterweisungUnterschreiben: { dbName: "Sicherheitsunterweisung unterschreiben lassen", stage: 'teilnehmerakte', position: 10 },
  verbisJobboerseUnterschreiben: { dbName: "Verbis- und Jobbörsennutzung unterschreiben lassen", stage: 'teilnehmerakte', position: 11 },
  potenzialanalyseAusfuellen: {
    dbName: "Aufnahme- und Potenzialanalyse ausfüllen",
    stage: 'teilnehmerakte',
    position: 12,
    landing: { modal: 'aufnahme-potenzialanalyse', tab: 'form' },
  },
  klettHochladen: {
    dbName: "Klett-Einstufungstest hochladen",
    stage: 'kompetenzfeststellung',
    position: 13,
    landing: { modal: 'kompetenzfeststellung', tab: 'klett' },
  },
  gevaHochladen: {
    dbName: "GEVA-Test hochladen",
    stage: 'kompetenzfeststellung',
    position: 14,
    landing: { modal: 'kompetenzfeststellung', tab: 'geva' },
  },
  bewertungsbogenJobcoach: {
    dbName: "Bewertungsbogen Jobcoach",
    stage: 'kompetenzfeststellung',
    position: 15,
    landing: { modal: 'kompetenzfeststellung', tab: 'jobcoach' },
  },
  bewertungsbogenFachanleiter: {
    dbName: "Bewertungsbogen Fachanleiter",
    stage: 'kompetenzfeststellung',
    position: 16,
    landing: { modal: 'kompetenzfeststellung', tab: 'anleiter' },
  },
  bewertungsbogenSprachlehrkraft: {
    dbName: "Bewertungsbogen Sprachlehrkraft",
    stage: 'kompetenzfeststellung',
    position: 17,
    landing: { modal: 'kompetenzfeststellung', tab: 'sprachlehrkraft' },
  },
  kompetenzbilanzierung: {
    dbName: "Kompetenzbilanzierung",
    stage: 'kompetenzbilanzierung',
    position: 18,
    landing: { modal: 'kompetenzbilanzierung', tab: 'kompetenzbilanzierung' },
  },
  foerderplanErstellen: {
    dbName: "Förderplan erstellen",
    stage: 'kompetenzbilanzierung',
    position: 19,
    landing: { modal: 'kompetenzbilanzierung', tab: 'foerderplan' },
  },
  foerderplanUnterschreiben: {
    dbName: "Förderplan unterschreiben lassen",
    stage: 'kompetenzbilanzierung',
    position: 20,
    landing: { modal: 'kompetenzbilanzierung', tab: 'foerderplan' },
  },
  foerderplanGegenzeichnen: {
    dbName: "Förderplan gegenzeichnen",
    stage: 'kompetenzbilanzierung',
    position: 21,
    landing: { modal: 'kompetenzbilanzierung', tab: 'foerderplan' },
  },
  erstberichtErstellen: {
    dbName: "Erstbericht erstellen",
    stage: 'kompetenzbilanzierung',
    position: 22,
    landing: { modal: 'kompetenzbilanzierung', tab: 'erstbericht' },
  },
  erstberichtUnterschreiben: {
    dbName: "Erstbericht unterschreiben lassen",
    stage: 'kompetenzbilanzierung',
    position: 23,
    landing: { modal: 'kompetenzbilanzierung', tab: 'erstbericht' },
  },
  erstberichtGegenzeichnen: {
    dbName: "Erstbericht gegenzeichnen",
    stage: 'kompetenzbilanzierung',
    position: 24,
    landing: { modal: 'kompetenzbilanzierung', tab: 'erstbericht' },
  },
  anwesenheitErfassen: { dbName: "Anwesenheit erfassen", stage: 'laufendeTeilnahme', position: 25 },
  zwischenberichtErstellen: { dbName: "Zwischenbericht erstellen", stage: 'zwischenbericht', position: 26 },
  zwischenberichtBesprechen: { dbName: "Zwischenbericht mit TN besprechen und unterschreiben", stage: 'zwischenbericht', position: 27 },
  abschlussberichtErstellen: { dbName: "Abschlussbericht erstellen", stage: 'abschlussOffen', position: 28 },
  abschlussberichtBesprechen: { dbName: "Abschlussbericht mit TN besprechen und unterschreiben", stage: 'abschlussOffen', position: 29 },
  abschlussberichtVerbisHochladen: { dbName: "Abschlussbericht (Nord_F.5_II) in VerBIS hochladen", stage: 'abschlussOffen', position: 30 },
  abgeschlossen: { dbName: "Abgeschlossen", stage: 'teilnahmeAbgeschlossen', position: 31 },
  aktivierung1: { dbName: "Kontakt per Telefon aufnehmen", stage: 'aktivierung', position: 32, landing: AKTIVIERUNG_LANDING },
  aktivierung2: { dbName: "Nichtantrittsmeldung hier herunterladen und in VerBIS hochladen", stage: 'aktivierung', position: 33, landing: AKTIVIERUNG_LANDING },
  aktivierung3: { dbName: "Fehlzeitenbrief 1 erstellen", stage: 'aktivierung', position: 34, landing: AKTIVIERUNG_LANDING },
  aktivierung4: { dbName: "Brief, Flyer und Häusliche Aktivierung für den Hausbesuch übergeben", stage: 'aktivierung', position: 35, landing: AKTIVIERUNG_LANDING },
  aktivierung5: { dbName: "Hausbesuch dokumentieren", stage: 'aktivierung', position: 36, landing: AKTIVIERUNG_LANDING },
  aktivierung6: { dbName: "Anrufen oder Mail 1 mit Termin Donnerstag, dokumentieren", stage: 'aktivierung', position: 37, landing: AKTIVIERUNG_LANDING },
  aktivierung7: { dbName: "Fehlzeitenbrief 2 erstellen", stage: 'aktivierung', position: 38, landing: AKTIVIERUNG_LANDING },
  aktivierung8: { dbName: "Brief 2, Flyer und Häusliche Aktivierung übergeben", stage: 'aktivierung', position: 39, landing: AKTIVIERUNG_LANDING },
  aktivierung9: { dbName: "Hausbesuch 2 dokumentieren", stage: 'aktivierung', position: 40, landing: AKTIVIERUNG_LANDING },
  aktivierung10: { dbName: "Anrufen oder Mail 2 mit Termin Dienstag, dokumentieren", stage: 'aktivierung', position: 41, landing: AKTIVIERUNG_LANDING },
  aktivierung11: { dbName: "Fehlzeitenbrief 3 erstellen", stage: 'aktivierung', position: 42, landing: AKTIVIERUNG_LANDING },
  aktivierung12: { dbName: "Brief 3, Flyer und Häusliche Aktivierung übergeben", stage: 'aktivierung', position: 43, landing: AKTIVIERUNG_LANDING },
  aktivierung13: { dbName: "Hausbesuch 3 dokumentieren", stage: 'aktivierung', position: 44, landing: AKTIVIERUNG_LANDING },
  aktivierung14: { dbName: "Anrufen oder Mail 3 mit Termin Montag, dokumentieren", stage: 'aktivierung', position: 45, landing: AKTIVIERUNG_LANDING },
  aktivierung15: { dbName: "F5.2-Bogen herunterladen und in VerBIS hochladen", stage: 'aktivierung', position: 46, landing: AKTIVIERUNG_LANDING },
  aktivierung16: { dbName: "Info-Mail an IFK schreiben", stage: 'aktivierung', position: 47, landing: AKTIVIERUNG_LANDING },
  aktivierung17: { dbName: "Fallabschluss dokumentieren", stage: 'aktivierung', position: 48, landing: AKTIVIERUNG_LANDING },
} satisfies Record<AufgabeKey, AufgabeEntry>
